// Generated TypeScript interfaces for interval_field_mode

export enum IntervalFieldMode {
  DISABLED = "disabled",
  OPTIONAL = "optional",
  REQUIRED = "required"
}

